import { createBrowserRouter } from 'react-router-dom';
import App, { AppLoader } from './App';
import Total, { TotalLoader } from '@features/content/Total';
import Powerbook, { PowerbookLoader } from '@features/content/Powerbook';
import Community, { CommunityLoader } from '@features/content/Community';
import Tag, { TagLoader } from '@features/content/Tag';
import Faq, { FaqLoader } from '@features/content/Faq';
import Guidebook, { GuidebookLoader } from '@features/content/Guidebook';
import Dictionary, { DictionaryLoader } from '@features/content/Dictionary';
import CharacterBns, { CharacterBnsLoader } from '@features/content/CharacterBns';
import CharacterAion, { CharacterAionLoader } from '@features/content/CharacterAion';
import Legion, { LegionLoader } from '@features/content/Legion';
import Guild, { GuildLoader } from '@features/content/Guild';
import NpUser, { NpUserLoader } from '@features/content/NpUser';
import Video, { VideoLoader } from '@features/content/Video';
import Nctv, { NctvLoader } from '@features/content/Nctv';
import Event, { EventLoader } from '@features/content/Event';
import Image, { ImageLoader } from '@features/content/Image';
import NoData from '@components/contents/common/NoData';
import Error, { ErrorLoader } from '@components/error/Error';
import { ALIAS, ROUTE, SERVICE_ALIAS, getBaseName } from '@constants/index';

export const getComponent = (option: IOption, alias?: string): { component: JSX.Element; loader: (dispatch: any, option: IOption) => any } => {
  const { serviceAlias } = option || {};
  let component;
  let loader;

  if (!alias) {
    component = <Error />;
    loader = ErrorLoader;
  } else {
    switch (alias) {
      case ALIAS.POWERBOOK:
        component = <Powerbook />;
        loader = PowerbookLoader;
        break;
      case ALIAS.COMMUNITY:
        component = <Community />;
        loader = CommunityLoader;
        break;
      case ALIAS.TAG:
        component = <Tag />;
        loader = TagLoader;
        break;
      case ALIAS.FAQ:
        component = <Faq />;
        loader = FaqLoader;
        break;
      case ALIAS.GUIDEBOOK:
        component = <Guidebook />;
        loader = GuidebookLoader;
        break;
      case ALIAS.DICTIONARY:
        component = <Dictionary />;
        loader = DictionaryLoader;
        break;
      case ALIAS.CHARACTER:
        const isBns = serviceAlias === SERVICE_ALIAS.BNS;
        component = isBns ? <CharacterBns /> : <CharacterAion />;
        loader = isBns ? CharacterBnsLoader : CharacterAionLoader;
        break;
      case ALIAS.LEGION:
        component = <Legion />;
        loader = LegionLoader;
        break;
      case ALIAS.GUILD:
        component = <Guild />;
        loader = GuildLoader;
        break;
      case ALIAS.NPUSER:
        component = <NpUser />;
        loader = NpUserLoader;
        break;
      case ALIAS.VIDEO:
        component = <Video />;
        loader = VideoLoader;
        break;
      case ALIAS.NCTV:
        component = <Nctv />;
        loader = NctvLoader;
        break;
      case ALIAS.EVENT:
        component = <Event />;
        loader = EventLoader;
        break;
      case ALIAS.IMAGE:
        component = <Image />;
        loader = ImageLoader;
        break;
      default:
        component = <Total />;
        loader = TotalLoader;
    }
  }

  return { component, loader };
};

export const setRouter = (store, option: IOption) => {
  const dispatch = store.dispatch;
  const { serviceAlias } = option || {};
  const routes = serviceAlias ? ROUTE[serviceAlias] : [];

  return createBrowserRouter(
    [
      {
        path: '/',
        element: <App />,
        loader: AppLoader(dispatch),
        children: routes?.map((v) => {
          const { component, loader } = getComponent(option, v?.key);
          return {
            path: v?.url,
            loader: loader(dispatch, option),
            element: component,
          };
        }),
        errorElement: <NoData />,
      },
      {
        path: '*',
        element: <Error />,
        loader: ErrorLoader(),
      },
    ],
    {
      basename: getBaseName(option),
    }
  );
};
